import React from 'react';
import {Field, reduxForm} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DoneIcon from 'material-ui/svg-icons/action/done';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import * as colors from 'material-ui/styles/colors';



import FormText from '../../../components/FormText'
import FormSelect from '../../../components/FormSelect'
import FormDatePicker from '../../../components/FormDatePicker'


class OverTimeMasterForm extends React.Component {


  render() {

    const {
      auth,
      branchOfficeData,
      departmentData,
      priceData,
      selectedBranchOfficeId,
      error,
      reset,
      handleSubmit,
      initialValues,
      onFormRegistClick,
      onFormSearchClick,
      onFormResetClick,
      onLocalStorageSave
     } = this.props

    return (

      <form onSubmit={handleSubmit(() => {})}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}
        
          <div className="row">

             <div className="col-3">

              <Field
                name="branchOfficeId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="支店名"
              >
                {
                  branchOfficeData && branchOfficeData.map((x, index) => {
                    return (<MenuItem key={index} value={x.id} primaryText={x.name} />)
                  })
                }
              </Field>

            </div> 

             <div className="col-3">

              <Field
                name="departmentId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="部署名"
              >

                <MenuItem value={''} primaryText="" />
                {!departmentData ? '' :
                selectedBranchOfficeId ?
                 departmentData.map((x, index) =>{
                   if (selectedBranchOfficeId == x.branchOfficeId) {
                      return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                   }
                 }) : 
                 <MenuItem primaryText="支店を選択" />
                }

              </Field>

            </div> 



          </div>

          <div className="row">

              <div className="col-3">
                  <Field
                      name="date"
                      component={FormDatePicker}
                      label="残業日"
                      textFieldStyle={{width: '100%'}}
                      style={{ width: '100%' }}
                  />
              </div>

              <div className="col-3">
                  <Field
                      name="startTime"
                      component={FormText}
                      label="開始時間"
                      style={{ width: '100%' }}
                  />
              </div>
              <div className="col-3">
                  <Field
                      name="endTime"
                      component={FormText}
                      label="終了時間"
                      style={{ width: '100%' }}
                  />
              </div>
          </div>

          <div className="row">
              <div className="col-6">
                  <Field
                      name="comment"
                      component={FormText}
                      label="残業理由"
                      style={{ width: '100%' }}
                  />
              </div>
          </div>

          <div className="row" style={{marginTop: 20}}>

            <div className="col-6" style={{paddingTop: 5, display: 'flex', justifyContent:'flex-start'}}>

              <FlatButton
                label="登録"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '100px', marginRight: '20px' }}
                backgroundColor={colors.cyan700}
                hoverColor={colors.cyan900}
                icon={<DoneIcon color={colors.white} />}
                onClick={handleSubmit(onFormRegistClick)}
              />

              {initialValues.id && 

                <FlatButton
                  label="編集モード終了"
                  primary={true}
                  labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                  style={{ height: '40px', width: '140px', marginRight: '20px' }}
                  onClick={onFormResetClick}
                />
              }

            </div>

            <div className="col-6" style={{textAlign: 'right'}}>
              <FlatButton
                label="クリア"
                primary={true}
                labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                onClick={() => {
                  reset()
                  onFormResetClick()
                }}
              />


              <FlatButton
                label="固定"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey700}
                icon={<LockIcon color={colors.white}/>}
                onClick={handleSubmit(onLocalStorageSave)}
              />

              <FlatButton
                label="検索"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '100px' }}
                backgroundColor={colors.blue500}
                hoverColor={colors.blue700}
                icon={<SearchIcon color={colors.white} />}
                onClick={handleSubmit(onFormSearchClick)}
              />

            </div>
          </div>

      </form>

    )

  }

}

OverTimeMasterForm = reduxForm({
  form: 'overTimeMasterForm',
  enableReinitialize: true,
})(OverTimeMasterForm)

export default OverTimeMasterForm




// WEBPACK FOOTER //
// ./src/containers/master/overTime/OverTimeMasterForm.js